<template>
  <!-- https://michalsnik.github.io/aos/ -->
  <v-container>

    <v-card class="mx-auto"  max-width="550">

    <v-system-bar  color="pink darken-2" @click.stop="$router.push('/home')">
      <v-icon>home</v-icon>
    </v-system-bar>
  

      <v-app-bar color="#424242" dark dense @click.stop="$router.push('/home')">
        <v-toolbar-title>Activity</v-toolbar-title>
      </v-app-bar>
 

      <v-card dark flat>

      <!-- Display the Schedule Button -->
        <!-- v-btn
          absolute
          bottom
          color="pink"
          right
          fab
          @click.stop="displayAddForm = !displayAddForm"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn -->
        
        <v-img
          src="/unsplash-exercise2.jpg" height="200px"
          gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
        >
        <v-container class="fill-height">
          <v-row align="center">
            <strong class="text-h2 font-weight-regular mr-7">{{totalActivityDuration}} mins</strong>
            <v-row justify="end">
              <div class="text-h5 font-weight-light">
                {{getTodaysDay}}
              </div>
              <div class="mr-4  text-uppercase font-weight-light">
               {{getTodaysDate}}

              </div>
            </v-row>
          </v-row>
        </v-container>
        </v-img>
      </v-card>


      <!--    SCHEDULE A SET    -->
      <div>     
        <v-row class="pt-1" cols="12">
          <v-col cols="12">

      <v-overlay position: absolute :opacity=0.7 :value=displayAddForm>
        <v-card>
          <div>
            <v-time-picker format="ampm"
              v-model="setTime"
              color="pink darken-2"
              header-color="pink darken-2"
            ></v-time-picker>
            <v-row align="center" class="d-flex dark flat">
              <v-col cols="12">
                <v-select
                  :items="setChoices"
                  label="Choose a set"
                ></v-select>
              </v-col>
            </v-row>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="grey darken-1" @click="createSet()">Schedule a session</v-btn>
            <v-spacer></v-spacer>                             
            <v-btn flat color="grey darken-1" @click="cancelSet()">Cancel</v-btn>
              <v-spacer></v-spacer>                                   
          </v-card-actions>        
        </v-card>
      </v-overlay>
      </v-col>
      </v-row>
      </div>



      <v-card-text class="py-0">

          <div v-if="todaysActivities.length==0">
            <v-row class="pt-1" cols="12">
  
          <v-col  cols="12">
            <v-card  color="grey darken-1"  dark >
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title class="text-h6">No activity today</v-card-title>

                </div>
              </div>
            </v-card>
           </v-col>


            </v-row>
          </div>      
          <div v-else>

      
          <!-- TODAY TIMELINE -->
          <v-timeline align-top dense>
            <v-timeline-item  color="green" small  v-for="(activity, index) in todaysActivities" :key="index">

              <v-row class="pt-1" cols="12">
                <v-col cols="2">
                  <strong>{{activity.date.substring(11, 16)}}</strong>
                </v-col>
                <v-col cols="10">
                  {{activity.createdAt.slice(11, 16) }} <strong>Set:</strong> {{activity.set}} ({{getTimeinHoursAndMinutes(activity.duration)}} mins)

                </v-col>
              </v-row>
            </v-timeline-item>
          </v-timeline> 
          </div>


          <!-- PREVIOUS DAYS TIMELINE -->
          <div v-if="activitiesList.length>0">     
              <v-row class="pt-1" cols="6">
                <v-col cols="12">
                  <p class="text-subtitle-1 ma-0 pa-0">Daily totals</p>
                </v-col>
              </v-row>
          </div>



          <div v-if="activitiesList.length>0">
          <v-timeline align-top dense>
            <v-timeline-item  color="blue" small  v-for="(activity, index) in activitiesList" :key="index">
              <v-row  class="pt-1" cols="12">
                <v-col cols="3">
                  <strong>{{activity["date"]}}</strong>
                </v-col>
                <v-col cols="9">  
                  <v-chip v-if="statusYellow(activity['durationStatus'])" color='yellow' text-color="grey" > {{getTimeinHoursAndMinutes(activity['duration'])}} mins  </v-chip>
                   <v-chip v-else :color='activity["durationStatus"]'  text-color="white" > {{getTimeinHoursAndMinutes(activity['duration'])}} mins  </v-chip>
                </v-col>
              </v-row>
            </v-timeline-item>
          </v-timeline> 
          </div>


      </v-card-text>
    </v-card>

    <v-navigation-drawer
     class="grey lighten-4"
      v-model="drawer"
      absolute
      bottom
      temporary
    >
      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4" >
          <v-list-item @click.stop="$router.push('/')">
            
            <v-list-item-icon>
              <v-icon>home</v-icon><span>Home</span></v-list-item-icon>        
            </v-list-item>

          <v-list-item @click.stop="$router.push('/sets')">
            <v-list-item-icon><v-icon>list</v-icon><span>Sets</span></v-list-item-icon>    
          </v-list-item>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<style>
.v-progress-circular {
margin: 1rem;
}
</style>





<script>
import { Auth } from 'aws-amplify'  
import queries from '../api/queries'
export default {

  name: 'Home',

  data: () => ({
    setTime: null,
    setList: [],
    minTime: "12:30",
    setChoices: [],
    sessionActivity: [],    
    displayAddForm:false,
    reverse: true,
    drawer: false,
    group: null,
    activitiesList: [],
    todaysActivities: [],
  }),
  async created() {
    

  },
 async mounted() {
    // REFACTOR into a computed
    this.userAuthData = await Auth.currentUserInfo();
    this.activitiesList = await queries.getActivitiesHistoryForUser(this.userAuthData.username);

    this.todaysActivities = await queries.getActivitiesForToday()
 

    // sort on createdAt
    this.todaysActivities.sort(function (a, b) {
    return a.createdAt.localeCompare(b.createdAt);
    });

    console.log(this.todaysActivities)
    this.todaysActivities.reverse()


    this.getSetList();
  },
   computed: {
      getTodaysDate: function () {
  
      let date = new Date();  
      let options = { year: 'numeric', month: 'long', day: 'numeric' };
 
      return(date.toLocaleString('default', options));
    },

    getTodaysDay: function () {
      let date = new Date();  
      let options = { weekday: 'long'};
      return(date.toLocaleString('default', options));
      },

    // duplicated in Home - refactor into index.js      
    totalActivityDuration: function () {
      let total=0;
      for (let i = 0; i < this.todaysActivities.length; i++) {  //loop through the array
      
        if(this.todaysActivities[i].status == 1) {
          total = total + parseInt(this.todaysActivities[i].duration); 
        }
           
        }
 
        var minutes = Math.floor(total / 60);
       
        return (minutes);
        },
      },  
  methods: {

    getSetList: function () {

        this.setList = this.$store.getters.setList;
        this.setChoices.push("I will choose later")
        for(var i = 0; i < this.setList.length; i++) {
          var obj = this.setList[i];
          this.setChoices.push(obj.title);
       
      }
    },
    cancelSet() {
        this.displayAddForm=false;
      },
      statusYellow(status) {
        if(status=='yellow')
          return true
        return false
      },  
    createSet() {
        this.displayAddForm=false;
      },  
    getTimeinHoursAndMinutes(duration){

      var minutes = Math.floor(duration / 60);
      minutes= Math.round(minutes + Number.EPSILON)
      var seconds = duration - minutes * 60;
      seconds= Math.round(seconds + Number.EPSILON)

      if(seconds < 10) {
          seconds = "0"+ seconds;
      }
    return(minutes + ":" + seconds);
    }
  }          
}
</script>
